export default __webpack_public_path__ + "static/media/testimonials-4.58081dc8.jpg";